
import SsrCarousel from 'vue-ssr-carousel'
import ssrCarouselCss from 'vue-ssr-carousel/index.css'
import jobsData from '@/data/jobs.json'
export default {
  components: { SsrCarousel },
props: {
  	country: {
      type: String
  	}
},
data() {
  return {
   jobs:[],
   loading:true,
   settings: {
      autoplay: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: true,
      infinite: false,
      arrows:true ,
      // centerMode:true,
      centerPadding: "30px",
      responsive: [
        {
          breakpoint: 400,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 740,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 1040,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
      ]
    },
    tinySliderOptions: {
      mouseDrag: true,
      loop: false,
      // items: this.jobsLength || 4,
      gutter: 20,
      swipeAngle: 45,
      controls: false,
      navPosition: 'bottom',
      lazyLoad:false,
      responsive:{
        400:{items:1},
        740:{items:2},
        900:{items:2},
        1040:{items:3}
      }
    },
  }
},
 async fetch() {
  console.log('filtering jobs')
  // const countryCapital = this.country.charAt(0).toUpperCase() + this.country.slice(1)
  function wordToUpper(str) {
    return (str + '').replace( /(^|[^a-z])([a-z])/g, function (m,p1,p2) {
        return p1+p2.toUpperCase();
    });
}
const countryCapital = wordToUpper(this.country)

      // const date = moment().format('YYYY-MM-DD')
//  const data = await this.$job(
// `query MyQuery {
//   jobs(where: {status: {_eq: "approved"}, application_deadline: {_gt: "${date}"}, geolocation_country_long: {_ilike: "${this.country}"}}, order_by: {featured: desc_nulls_last}, limit: 8) {
//     id
//     created_at
//     job_link
//     title
//     company_tagline
//     thumbnail
//     geolocation_country_long
//     contract_type
//     description
//     featured
//     status
//     school_type
//   }
// }`
 this.jobs = await jobsData.filter((job) => job.geolocation_country_long === countryCapital && Math.floor(new Date(job.application_deadline).getTime() / 1000) > Math.floor(new Date().getTime() / 1000))



// )
// const data = {}
//   if(jobs.length>0){
//       this.jobs=data.jobs
//       }else{
//         this.jobs=[]
//       }

//      this.jobsLength = this.jobs.length

//     } catch (error) {
//       console.log(error)
//     }
  this.loading=false
 },
 computed: {
  firstTen() {
  return this.jobs.slice(0, 10)
 },
 jobsLength() {
  return this.firstTen.length
 }
 },

methods: {
          goNext() {
            this.$refs.tinySlider.slider.goTo('next')
          },
          goPrevious() {
            this.$refs.tinySlider.slider.goTo('prev')
          },
        }

}
